import React from "react";
import AccidentForm from "./components/AccidentForm";

const App: React.FC = () => {
  return <AccidentForm />;
};

export default App;
